import { TutuWidget, tutuWidgetName } from 'types/tutu';

export const tutuOptions = Object.values(TutuWidget).map(value => ({
  value,
  label: tutuWidgetName[value],
}));
